<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtModel"
              formControlName="Model"
              #focusElement
              [ngClass]="{'is-invalid': submitted && fc.Model.invalid}"
              [Label]="'ACTION.MODEL.SINGULAR'">
            </yt-input>
              <div class="form-error" *ngIf="submitted && fc.Model.invalid">
                  <span *ngFor="let validation of errorMessages.Model">
                    <span class="error-message" *ngIf="fc.Model.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
              </div>              
            </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtNaziv"
              formControlName="Name"
              #focusElement
              [ngClass]="{'is-invalid': submitted && fc.Name.invalid}"
              [Label]="'ACTION.NAZIV.SINGULAR'">
            </yt-input>
              <div class="form-error" *ngIf="submitted && fc.Name.invalid">
                  <span *ngFor="let validation of errorMessages.Name">
                    <span class="error-message" *ngIf="fc.Name.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
              </div>              
            </div>
        </div>
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="MESTO.POSTBROJ.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtOpis"
              formControlName="Description"
              #focusElement
              [ngClass]="{'is-invalid': submitted && fc.Description.invalid}"
              [Label]="'ACTION.OPIS.SINGULAR'">
            </yt-input>             
            </div>
        </div>
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="FIRMAEMAIL.GLAVNI.SINGULAR"></span></label>
          <div class="col-md-1">
            <input
              style="width: 20px;"
              type="checkbox"
              name="chkGlavni"
              class="form-control"
              formControlName="Glavni"
              autocomplete="off"
              >
          </div> -->
          <div class="col-md-12">
              <div class="form-check" style="padding-top: 22px">
                <input
                class="form-check-input" 
                type="checkbox"
                formControlName="DefaultValue"
                id="chkDefault"
                >
                <label class="form-check-label" for="chkDefault"><span translate="ACTION.DEFAULTVALUE.SINGULAR"></span></label>
              </div>
            </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <yt-multiselect
            [ModelName]="'userrole'"
            [GetName]="'get'"
            [ModelProperty]="'Name'"
            [OrderBy]="'Name'"
            [AllowAddNew]="false" 
            formControlName="RoleIDs"
            [Type]="'ID'"
            [Label]="'ACTION.ROLE.SINGULAR'">
          </yt-multiselect>
          </div>
      </div>
    </div>
  </div>
  </div>
</form>